export const routes = (parentName) => {
  return [
    {
      path: "agahi-management",
      component: () => import("./Index.vue"),

      children: [
        {
          path: "checking",
          name: `${parentName}-Agahi-Management-Checking`,
          component: () => import("./List.vue"),
        },
        {
          path: "active",
          name: `${parentName}-Agahi-Management-Active`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "deactive",
          name: `${parentName}-Agahi-Management-Deactive`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: ":id/edit",
          // name: `${parentName}-Agahi-Management-Edit`,
          name: parentName + "-" + "Agahi-Management-Edit",
          component: () => import("./Upsert.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
      ],
    },
  ];
};
